export default __webpack_public_path__ + "static/media/lasker.dc227e8e.txt";